import { CircularProgress, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { Input } from "@accredo/fe-shared/theme/components";

/**
 * The search field look every list page shares: full width, a search icon,
 * the placeholder "Vertrag, Objekt oder Dokument suchen …" (R-SEARCH-01).
 * Purely presentational and controlled - what typing into it does differs by
 * caller: the dashboard's GlobalSearch wraps it with a cross-entity dropdown,
 * each list table wraps it with its own server-side filter[_searchword].
 *
 * `isLoading` swaps the search icon for a spinner while a request for the
 * current input is in flight - optional, so callers with no loading state
 * of their own (most list tables) are unaffected.
 */
export default function SearchField({
  value,
  onChange,
  sx,
  isLoading = false,
  ...props
}) {
  return (
    <Input
      fullWidth
      placeholder="Vertrag, Objekt oder Dokument suchen …"
      value={value}
      onChange={onChange}
      sx={{ mb: 3.5, ...sx }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              {isLoading ? (
                <CircularProgress
                  size={16}
                  data-testid="search-field-spinner"
                  sx={{ color: "text.secondary" }}
                />
              ) : (
                <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
              )}
            </InputAdornment>
          ),
        },
      }}
      {...props}
    />
  );
}
